import {
    createAsyncThunk,
    createSlice,
    isRejectedWithValue,
} from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from "../../shared/config/environment";

const initialState = {
    accessToken: {},
    isOtpVerify: false,
    isLoggedIn: false,
    tenants: [],
    currentTenant: {},
    loading: false,
    error: false,
    errorMessage: {},
    user: {},
    phone: "",
    otpErrorMessage: {},
    logoutStatus: false,
    otpStatus: '',
    verifyAccountStatus: false,
    authenticationDetails: {},
    authCodeStatus: false,
    loading: false,
    verifyAccountError:false

};

export const register = createAsyncThunk("auth/addNew", async (loginCreds) => {
    try {
        const last10Digits = loginCreds.phone;

        var config = {
            method: "POST",
            url: environment.URL + "auth/direct-login",
            data: { phone: last10Digits },
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await axios(config);


        return last10Digits;
    } catch (error) {

        throw error;
    }
});

export const otpVerify = createAsyncThunk("auth/otpVerify", async (data) => {
    try {
        const result = {
            phone: data.phone,
            otp: data.otp,
        };

        var config = {
            method: "POST",
            url: environment.URL + "auth/verify-otp",
            data: result,
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await axios(config);


        return response.data;

    } catch (error) {

        throw new Error(error);
    }
});

export const verifyAccountDetails = createAsyncThunk(
    "auth/verifyAccount",
    async (args, { rejectWithValue }) => {
        const data = {
            authenticate_code: args?.code,
        };
        try {
            var config = {
                method: "POST",
                url: environment.URL + `authentication/get-verifycode`,
                headers: {
                    "Content-Type": "application/json",
                },
                data: data,
            };
            const response = await axios(config);

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const fetchAccountDetails = createAsyncThunk(
    "auth/fetchToken",
    async (args, { rejectWithValue }) => {
        ;
        try {
            var config = {
                method: "GET",
                url: environment.URL + `authentication/get-authenticate/${args?.id}`,
                headers: {
                    "Content-Type": "application/json",
                },
            };
            const response = await axios(config);

            return response.data;
        } catch (error) {

            return rejectWithValue(error);
        }
    }
);


export const fetchAllTenants = createAsyncThunk(
    "sharedSlice/fetchTenant",
    async (id, { rejectWithValue }) => {

        try {
            var config = {
                method: "GET",
                url: environment.URL + `authentication/get-tenants/${id}`,
                headers: {
                    "Content-Type": "application/json",
                },
            };
            const response = await axios(config);

            return response.data;
        } catch (error) {

            return rejectWithValue(error);
        }
    }
);





const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: () => initialState,
        verifyUser(state, action) {
            state.user = action.payload
        },
        resetAuth(state, action) {
            state.isOtpVerify = false;
            state.verifyAccountStatus = false;
            state.loading = false;
            state.verifyAccountError = false
        },
        resetError(state, action) {
            state.error = false;
            state.otpStatus = '';
            state.otpErrorMessage = '';
            state.isOtpVerify = false;
            state.loading = false;
            state.verifyAccountError = false
        }

    },
    extraReducers(builder) {
        builder
            .addCase(register.pending, (state, action) => {
                 state.loading = true;
            })
            .addCase(register.fulfilled, (state, action) => {
                state.phone = action.payload;
                state.status = true;
                state.otpStatus = "sent";
                state.loading = false;
            })
            .addCase(register.rejected, (state, action) => {
                state.status = false;
                state.error = true;
                state.otpStatus = "error";
                state.loading = false;
            })
            .addCase(otpVerify.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(otpVerify.fulfilled, (state, action) => {
                state.isOtpVerify = true;
                state.accessToken = action.payload?.access_token;
                state.isLoggedIn = true;
                state.tenants = action.payload?.tenants;
                state.user = action.payload?.user;
                state.otpStatus = "verified";
                state.loading = false;
            })
            .addCase(otpVerify.rejected, (state, action) => {
                state.isLoggedIn = false;
                //state.error = true;
                state.otpErrorMessage =
                    "OTP verification failed. Please try again later."
                state.otpStatus = "error";
                state.loading = false;
            })
            .addCase(fetchAccountDetails.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(fetchAccountDetails.fulfilled, (state, action) => {
                state.authCodeStatus = true;
                state.authenticationDetails = action.payload;
                state.loading = false;
            })
            .addCase(fetchAccountDetails.rejected, (state, action) => {
                state.authCodeStatus = false;
                state.error = action.payload.message;
                state.loading = false;
            })
            .addCase(verifyAccountDetails.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(verifyAccountDetails.fulfilled, (state, action) => {
                state.verifyAccountStatus = true;
                state.loading = false;
                state.isLoggedIn = true
                state.userData = action.payload;
                state.tenants = action.payload?.tenants;
                state.accessToken = action.payload?.access_token;
            })
            .addCase(verifyAccountDetails.rejected, (state, action) => {
                state.loading = false;
                state.isLoggedIn = false;
                state.verifyAccountStatus = false;
                state.verifyAccountError = true
                state.error = action.payload?.message ? action.payload?.message : "";
            })
            .addCase(fetchAllTenants.fulfilled, (state, action) => {
                state.tenants = action.payload?.tenants;
            })
            .addCase(fetchAllTenants.rejected, (state, action) => {

            })
    }
});

export default authSlice.reducer;

export const {
    logout,
    verifyUser, resetAuth, resetError
} = authSlice.actions;